export const CHANGETEXT = "filters/changetext";
export const CHANGEAUTHOR = "filters/changeauthor";
export const CHANGECATEGORIES = "filters/changecategories";
export const CLEAR = "filters/clear";
